const mainTag = 'nayom26';
export const MetricTags = {
    registr: 'registr',
    anyTicket: `buy_${mainTag}`,
    offline: `buy_${mainTag}_offline`,
    online: `buy_${mainTag}_online`,
    hybrid: `buy_${mainTag}_hybrid`,
    vip: `buy_${mainTag}_vip`
};
